import { ErrorHandler, Injectable } from "@angular/core";
import isEqual from 'lodash/isEqual';

import { EidosErrorDialogComponent } from "@common/components/dialogs/eidos-error-dialog/eidos-error-dialog.component";
import { EidosLogSeverity } from "@common/models/core-constant.model";
import { CoreModalService, ModalBaseActions } from "./services/core-modal.service";
import { EidosLogService } from "./services/eidos-log.service";
import { EidosUtilityService } from "./services/eidos-utility.service";
import { EidosSecurityService } from "./services/eidos-security.service";

/**
 * Main application error handler
 *
 * @export
 * @class CoreErrorHanlder
 * @implements {ErrorHandler}
 */
@Injectable()
export class CoreErrorHandler implements ErrorHandler {

  constructor(
    private coreModalService: CoreModalService,
    private coreUtilityService: EidosUtilityService,
    private eidosSecurityService: EidosSecurityService,
    private coreLogService: EidosLogService
  ) {
  }
  /**
   * Handles a client side error
   *
   * @param {Error} clientError
   * @memberof CoreErrorHandler
   */
  public handleError<T extends Error>(clientError: T) {
    const skipLog = this.skipLog(clientError);

    if (!skipLog && this.eidosSecurityService.isAuthenticated()) {

      // Log the error on debug mode
      this.coreLogService.logDebug(EidosLogSeverity.Error, clientError);

      if (this.coreUtilityService.skipNextError) return;
      if(clientError?.message?.includes('IDBDatabase')) return

      this.coreUtilityService.inDebugMode.subscribe(debug => {
        if (this.eidosSecurityService.isDeveloperUser() && debug) {
          this.coreModalService.open(EidosErrorDialogComponent, {
            data: clientError,
            dimensions: { width: '50%' },
            hasActions: ModalBaseActions.NONE,
            closeOnEscOrBackdropClick: true,
          });
        }
      });

      // Don't send log to DB at the moment
      // this.coreApiService.logClientSideError(clientError).subscribe({
      //   next: (response: boolean) => {
      //     if (response) {
      //       // Log the error on debug mode
      //       this.coreLogService.logDebug(EidosLogSeverity.Error, clientError);

      //       this.coreUtilityService.inDebugMode.subscribe(debug => {
      //         if (!!debug) {
      //           this.coreModalService.open(EidosErrorDialogComponent, {
      //             data: clientError,
      //             dimensions: { width: '50%' },
      //             hasActions: ModalBaseActions.NONE,
      //             closeOnEscOrBackdropClick: true,
      //           });
      //         }
      //       });
      //     }
      //   },
      //   error: error => {
      //     this.coreLogService.logDebug(EidosLogSeverity.Error, error);

      //     this.coreUtilityService.inDebugMode.subscribe(debug => {
      //       if (!!debug) {
      //         this.coreModalService.open(EidosErrorDialogComponent, {
      //           data: clientError,
      //           dimensions: { width: '50%' },
      //           hasActions: ModalBaseActions.NONE,
      //           closeOnEscOrBackdropClick: true,
      //         });
      //       }
      //     });
      //   },
      //   complete: () => {
      //   }
      // });
    }
  }

  /**
   * Skip some verboses logs
   *
   * @private
   * @param {*} clientError
   * @return {*}  {boolean}
   * @memberof CoreErrorHandler
   */
  private skipLog(clientError: any): boolean {

    if(clientError.name == 'SchemaError' )return true;

    // Skip https://angular.io/errors/NG0100
    if (clientError.code === -100) {
      return true;
    }

    if (isEqual(this.coreLogService.lastLoggedError, clientError)) {
      return true;
    }

    this.coreLogService.lastLoggedError = clientError;

    return false;
  }
}
